import React from "react";

const ProfessionalDetails = ({ t, plan }) => {
  return (
    <ul>
      {plan === "yearly"?<li>
            <img src="/images/sp-icon.svg" alt=""/>
            <span>Free access to all Marketplace Strategies</span>
        </li>:<></> }
      <li>
          <img src="/images/sp-icon.svg" alt=""/>
          <span>50 {t("active-bots")}</span>
      </li>
      <li >
        <img src="/images/sp-icon.svg" alt=""/>
        <span>1 and 5 minute trading frequency</span>
      </li>
      <li >
        <img src="/images/sp-icon.svg" alt=""/>
        <span> Custom Backtest Period</span>
      </li>
      <li >
        <img src="/images/sp-icon.svg" alt=""/>
        <span>Extended-hours trading</span>
      </li>
      <li >
        <img src="/images/sp-icon.svg" alt=""/>
        <span>Grid strategy bot</span>
      </li>
      {plan === "yearly" ? (
        <li >
          <img src="/images/sp-icon.svg" alt=""/>
          <span>Intrinsic Intelligence</span>
        </li>
      ) : null}
      <li >
        <img src="/images/sp-icon.svg" alt=""/>
        <span> SMS/WhatsApp notifications</span>
      </li>
      {plan === "yearly" && (
        <>
          <li>
            <img src="/images/sp-icon.svg" alt=""/>
            <span>{t("subscription-modify-marketplace-exit-levels")}</span>
          </li>
          <li>
            <img src="/images/sp-icon.svg" alt=""/>
            <span>{t("subscription-developer-api-access")}</span>
          </li>
        </>
      )}
    </ul>
  );
};

export default ProfessionalDetails;
